import { WebEditorShell } from '@adornis/web-editor/client/legacy/EditorShell.js';
import { LandingEditorPropertiesView } from './editorPropertiesView.js';
import { editorLogin } from './editorLogin.js';
import { renderEditorCommentComposer, renderEditorCommentPopover, renderEditorCommentsPanel } from './editorCommentsView.js';
import { scrollEditorCommentIntoView } from './editorCommentOverlay.js';
import { renderEditorAssetsPanel } from './editorAssetsView.js';
import { renderEditorMediaInspector, renderEditorMediaLibrary } from './editorMediaLibraryView.js';
export class LandingEditorView extends WebEditorShell {
  constructor(context: Record<string, any>) { super(context, {
    PropertiesView: LandingEditorPropertiesView, editorLogin, renderEditorCommentComposer,
    renderEditorCommentPopover, renderEditorCommentsPanel, scrollEditorCommentIntoView,
    renderEditorAssetsPanel, renderEditorMediaInspector, renderEditorMediaLibrary,
  }); }
}
